module.exports = __webpack_public_path__ + "img/Matrix-2022.8dc81334.jpg";